// extracted by mini-css-extract-plugin
export default {"FullPage":"logout_FullPage__ydJHy","LogoutSpinner":"logout_LogoutSpinner__b-AHO","LogoutText":"logout_LogoutText__R+W9O"};